import { filter } from "underscore";
import { create } from "zustand";
import { devtools } from 'zustand/middleware'

export const useFiltrosStore = create(devtools((set, get) => ({
    vehiculos: [],
    vehiculosFiltrado: [],
    eventoSeleccionado: [],
    setVehiculos: (data = []) => {
        set(() => ({
            vehiculos: data
        }))
    },
    setVehiculosFiltrados: (grupos = []) => {

        let _vehiculos = []
        const _vhs = get().vehiculos

        grupos.map((uid_grupo) => {

            const _filtro = filter(_vhs, function (obj) { return obj.uid_grupo == uid_grupo })

            _filtro.map((i) => _vehiculos.push(i))
        })

        set((state) => ({

            vehiculosFiltrado: grupos.length > 0 ? _vehiculos : state.vehiculos
        }))
    },
    setEventoSeleccionado: (evento) => {
        set(() => ({
            eventoSeleccionado: evento
        }))
    },
    reiniciar: () => {
        set({
            vehiculos: [],
            vehiculosFiltrado: [],
            eventoSeleccionado: []
        });
    }
})))